<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Create from './Create.vue'
	import Edit from './Edit.vue'
	import Navbar from './../../../customers/views/Navbar.vue'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'create': Create,
			'edit': Edit,
			'navbar': Navbar,
		},
		data () {
			return {
				data: null,
				item: null,
				loading: false,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
				this.getCustomer()
			},
			reload() {
				this.getData()
				this.getCustomer()
			},
			getData() {
				this.loading = true
				this.$http.get('admin/customers/' + this.$route.params.id + '/billings')
				.then(response => {
					this.loading = false
					this.data = response.body
				}).catch(function(response) {
					this.loading = false
					console.log(response)
				})
			},
			getCustomer() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			destroy(data) {
				var loading = Ladda.create(document.querySelector('#btn-destroy-billing-' + data.id))
				loading.start()
				this.$http.delete('admin/management/billings/' + data.id)
				.then(response => {
					loading.stop()
					this.reload()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					loading.stop()
					this.$emit('reload')
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
			changeMain(data) {
				this.loading = true
				this.$http.get('admin/customers/' + this.$route.params.id + '/billings/main/' + data.id)
				.then(response => {
					this.loading = false
					this.reload()
				}).catch(function(response) {
					this.loading = false
					this.reload()
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/billings/views/Index.vue